import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { FileUploadProcessComponent, SpecificationsFormulaSettingsComponent } from 'src/app/components/dialog';
import { Lang, FileData, Res } from 'src/app/models';
import { NotificationService, DialogModalService, ValidatorsService, LanguageService } from 'src/app/services';
import { ApiMainSettingsService } from 'src/app/services/api-main-settings.service';
import { ApispecificationService } from 'src/app/services/api-specifications.service';
import { SpecificationsActionsValidator } from '../specifications-actions-validator';

@Component({
  selector: 'app-specifications-create',
  templateUrl: './specifications-create.component.html',
  styleUrls: ['./specifications-create.component.css']
})
export class SpecificationsCreateComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  multiple: boolean = false;
  component: string = 'specifications';
  specificationName: Lang;
  file: FileData = null;
  errorMessages: any;
  specifications: any[] = [];
  isFormula: boolean[] = [];
  formula: any[] = [];
  attributes: any[] = [];
  readonly: boolean[] = [];
  formulaForEdit: any[] = [];
  formats: any[] = [
    {
      id: 'text',
      name: 'Текстовое'
    },
    {
      id: 'number',
      name: 'Числовое'
    },
    {
      id: 'date',
      name: 'Дата'
    }
  ]
  langs: any[] = [
    {
      id: 'ru',
      name: 'Русский'
    },
    {
      id: 'en',
      name: 'Английский'
    },
    {
      id: 'kz',
      name: 'Казахский'
    }
  ]
  types: any[] = [
    {
      id: 'attribute',
      name: 'Атрибут'
    },
    {
      id: 'formula',
      name: 'Формула'
    }
  ]

  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  form: UntypedFormGroup = this.fb.group({
    name: [null, Validators.required],
    specifications: this.fb.array([])
  });

  constructor(
    private router: Router,
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private apiSpecificationsService: ApispecificationService,
    private languageService: LanguageService,
    private notification: NotificationService,
    private dialogModal: DialogModalService,
    private validator: SpecificationsActionsValidator,
    private apiSettings: ApiMainSettingsService,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.errorMessages = this.validator.errorMessages;

    // this.addFilterFields();
  }


  /**
   * 
   * @param fieldName 
   * @param value 
   */
  eventFnFF(fieldName: string, value: Lang): void {

    this.form.controls[fieldName].setValue(value);
  }


  /**
   * 
   * @param event 
   */
  onUploadedFile(event: any) {

    this.notification.show('success', 'Файл успешно загружен!');

    this.setFormData(event.result);

    this.file = event.result;
  }

  /**
   * 
   * @param file 
   */
  onFileDropped(file: FileData) {

    console.log("FILE: ", file);


    let data = {
      files: file,
      option: {
        multiple: this.multiple,
        component: this.component
      }
    }

    console.log("FILE DATA: ", data);


    this.dialogModal.open(data, FileUploadProcessComponent).then(
      (response) => {

        if (response) {

          this.notification.show('success', 'Файл успешно загружен!');

          this.setFormData(response.result)


          this.file = response.result;

        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
   * 
   */
  setFormData(fileData) {


    if (fileData != null) {

      fileData.forEach((element, index) => {

        this.addMappingFieldsWithdata(element, index);
      });
    }
  }

  /**
  * 
  * @param type string
  */
  addMappingFieldsWithdata(fileData: any, index: number): void {

    let control = this.form.controls.specifications as UntypedFormArray;
    control.push(this.setMappingData(fileData, index));
  }

  /**
  * 
  * @param referenceData 
  * @returns 
  */
  setMappingData(fileData: any, index: number) {

    return this.fb.group({
      field: [index++],
      column_name: [fileData, this.validator.field],
      type: [null, this.validator.type],
      requirement: [null, this.validator.requirement],
      lang_code: [null]
    });
  }

  /**
   * 
   */
  deleteFile() {

    this.form.get('file').setValue(null);
    this.file = null;
  }

  /**
   * 
   * 
   */
  addFilterFields(): void {

    let control = this.form.controls.specifications as UntypedFormArray;
    control.push(this.initFilterField(control.length));
  }

  /**
  * 
  * @param i number
  */
  removeFilterField(index: number): void {

    let control = this.form.controls.specifications as UntypedFormArray;
    control.removeAt(index);

    //так же чистим переменные для проверки отрисовки кнопки добавления/информации формулы
    this.isFormula[index] = false;
    this.formula[index] = null;

    for (let i = 0; i < control.length; i++) {

      // this.onListenerType(i);

      this.form.get(['specifications', i, 'field']).setValue(i + 1);

      // this.onListenerAttribute(i);

    }
  }

  /**
  * 
  * 
  */
  initFilterField(index: number): any {

    return this.fb.group({
      field: [index + 1],
      column_name: [null, this.validator.field],
      type: [null, this.validator.type],
      requirement: [null, this.validator.requirement],
      lang_code: [null]
    });

  }

  /**
   * 
   */
  onListenerType(index: number) {

    // this.form.get(['specifications', index, 'requirement']).setValue(null);

    console.log("TYPE: ", this.form.get(['specifications', index, 'requirement']).value);


    let currentVal = this.form.get(['specifications', index, 'type']).value;

    currentVal != null && currentVal == 'formula' ? this.isFormula[index] = true : this.isFormula[index] = false;

    if (currentVal == 'attribute') {

      this.getAttirbutes();
      this.onListenerAttribute(index);
    }
  }

  /**
   * 
   */
  onListenerAttribute(index: number) {

    let currentVal = this.form.get(['specifications', index, 'requirement']).value;

    console.log("CURRENT VAL: ", currentVal);

    if (currentVal != null && !currentVal.multilang) {

      this.form.get(['specifications', index, 'lang_code']).setValue(null)
    }

    if (currentVal != null) {

      this.readonly[index] = currentVal.multilang

    }

  }

  /**
  * 
  */
  getAttirbutes(): void {

    this.progressRef.start();

    let data = {
      ref_name: "attr_spec_list",
      filter: {
        ref_type: "ATTRIBUTE"
      }
    }

    this.subscriptions.add(
      this.apiSpecificationsService.getReferences(data, data.ref_name).subscribe((response: Res) => {
        console.log('[RESPONSE] getTypesActions: ', response);

        if (response != null && response.result != null) {

          this.attributes = response.result;

        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }



  /**
   * 
   */
  backTo() {

    this.router.navigate(['settings']);

    setTimeout(() => this.apiSettings.switchTab('specifications'), 1000)


  }

  /**
   * 
   */
  onCreateFormula(index: number) {

    this.loading = true;

    let data = null;

    this.dialogModal.open(data, SpecificationsFormulaSettingsComponent, 'xl').then(

      (result) => {

        if (result) {

          this.convertFormulaData(result, index);

        }

        this.loading = false;
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
   * 
   * @param index 
   */
  onEditFormula(index: number) {

    this.loading = true;

    let data = {
      isFormulaEdit: true,
      formulaForEdit: this.formulaForEdit[index]
    }

    this.dialogModal.open(data, SpecificationsFormulaSettingsComponent, 'xl').then(

      (result) => {

        if (result) {

          this.convertFormulaData(result, index);
        }

        this.loading = false;
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
   * 
   * @param formula 
   */
  convertFormulaData(formulaFormValue: any, index: number) {

    let formula_fields_for_create: any[] = [];

    for (let i = 0; i < formulaFormValue.length; i++) {

      formula_fields_for_create.push({

        id: formulaFormValue[i].value_type.id,
        name: formulaFormValue[i].value_type.name ? formulaFormValue[i].value_type.name : formulaFormValue[i].value_type,
        type: formulaFormValue[i].type_field.id ? formulaFormValue[i].type_field.id : null,
        lang_code: formulaFormValue[i].lang_code

      });

    }
    
    console.log("FORMULA RESULT: ", formula_fields_for_create);

    this.formula[index] = formula_fields_for_create;
    this.formulaForEdit[index] = formulaFormValue;
    this.form.get(['specifications', index, 'requirement']).setValue(formula_fields_for_create);

  }

  /**
   * 
   * @param i 
   */
  removeFormulaField(i: number): void {

    this.formula[i] = null;
  }

  /**
   * 
   */
  onCreate() {

    let form = { ...this.form.value };

    let control = this.form.controls.specifications as UntypedFormArray;

    for (let i = 0; i < control.value.length; i++) {

      if (control.value[i].type == "attribute") {

        control.value[i].requirement = [{

          type: "attribute",
          id: control.value[i].requirement.id,
          name: control.value[i].requirement.name,
          lang_code: control.value[i].lang_code

        }]

      }

    }

    this.progressRef.start();
    this.loading = true;

    console.log("FORM: ", form);


    this.subscriptions.add(

      this.apiSpecificationsService.create(form).subscribe((response: Res) => {
        console.log('[RESPONSE] SPEC_EDIT_DATA: ', response);

        if (response != null) {

          this.notification.show('success', 'Спецификация успешно создана!');

          this.router.navigate(['settings']);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );

  }

  /**
 * 
 * @param field 
 * @param type 
 */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }


}
